<template>
  <div class="fact">
    <form v-if="showingForm && editable">
      <label class="cm-label" for="breakfast-foods">{{ I18n.t("activerecord.attributes.company.breakfast_food") }}</label>
      <div class="field">
        <CmSelect
          class='breakfast-foods__select'
          name="breakfast-foods"
          v-model="value"
          :options="options"
          :label="I18n.t('choose_breakfast_food')"
        />
      </div>
      <div class="form-action-row">
        <input @click.prevent="saveForm" type="submit" class="cm-button save-changes" :value="I18n.t('save')" />
        <button class="cancel-button" type="button" @click="showForm">{{ I18n.t('cancel') }}</button>
      </div>
    </form>
    <template v-else>
      <div class="fact__header">{{ I18n.t("activerecord.attributes.company.breakfast_food") }}</div>
      <div class="fact__text">
        <span>{{ value ? I18n.t('breakfast_foods.' + value) : I18n.t('choose_breakfast_food') }}</span>
        <button v-if="editable" @click="showForm" class="edit-button ss-icon">compose</button>
      </div>
    </template>
  </div>
</template>

<script>
import CmSelect from "../components/select";

export default {
  components: {
    CmSelect
  },

  props: ["company", "breakfastFoods", "editable"],

  data() {
    return {
      value: this.company.breakfast_food,
      showingForm: false,
      breakfastFoods: this.breakfastFoods
    };
  },
  computed: {
    options() {
      return Object.keys(this.breakfastFoods).map(key => ({
        label: this.breakfastFoods[key],
        value: key
      }));
    }
  },
  methods: {
    showForm() {
      this.showingForm = !this.showingForm;
    },

    saveForm() {
      let attrs = {
        breakfast_food: this.value
      };

      this.$http
        .patch("/companies/" + this.company.slug, { company: attrs })
        .then(
          response => {
            // TODO Emit updated data to parent?
            this.showingForm = false;
          },
          response => {
            // TODO Display error messages
          }
        );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../components/edit-button";
</style>



// WEBPACK FOOTER //
// app/javascript/company/breakfast-food.vue?61bf9f3a